// extracted by mini-css-extract-plugin
export default {"steps":"style_steps__KGSr5","active":"style_active__rkbxN"};